import React from "react";
import { m as motion } from "../../shared/components/Motion";
import "./footer.css";
import {
  containerVariants,
  childVariantsMedium as childVariants,
} from "../../shared/utils";

const navigationItems = ["About", "Projects", "Skills"];

const socialLinks = [
  {
    href: "https://www.facebook.com/sansivkumar1",
    iconClass: "bx bxl-facebook",
    title: "facebook-sansivkumar1",
  },
  {
    href: "https://www.instagram.com/santhoshsivkumar",
    iconClass: "bx bxl-instagram",
    title: "instagram-santhoshsivkumar",
  },
  {
    href: "https://x.com/sansivkumar",
    iconClass: "bx bxl-twitter",
    title: "twitter-sansivkumar",
  },
];

const Footer = () => {
  const myName = " Santhosh Sivakumar";

  return (
    <motion.footer
      className="footer"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.div
        className="footer__container container"
        variants={containerVariants}
      >
        <motion.h1 className="footer__title" variants={childVariants}>
          Let's work together...
        </motion.h1>
        <motion.ul className="footer__list" variants={containerVariants}>
          {navigationItems.map((title, index) => (
            <motion.li key={index} variants={childVariants}>
              <a
                title={title}
                href={`#${title.toLowerCase()}`}
                className="footer__link"
              >
                {title}
              </a>
            </motion.li>
          ))}
        </motion.ul>
        <motion.div className="footer__social" variants={containerVariants}>
          {socialLinks.map((link, index) => (
            <motion.a
              title={link.title}
              key={index}
              href={link.href}
              className="footer__social-link"
              target="_blank"
              rel="noopener noreferrer"
              variants={childVariants}
            >
              <i className={link.iconClass}></i>
            </motion.a>
          ))}
        </motion.div>
        <motion.span className="footer__codedBy" variants={childVariants}>
          Coded By
          <span className="footer__ownerName">{myName}</span>
        </motion.span>

        <motion.span className="footer__copy" variants={childVariants}>
          &#169; 2024 Created for Practice
          <i className="bx bx-wink-smile"></i>
        </motion.span>
      </motion.div>
    </motion.footer>
  );
};

export default Footer;
